export default {
  product: null,
  products: null,
  unitsOfMeasure: [
    "descripción",
    "bobinas",
    "balde",
    "barriles",
    "bolsa",
    "botellas",
    "caja",
    "cartones",
    "centimetro cuadrado",
    "centimetro cubico",
    "centimetro lineal",
    "ciento de unidades",
    "cilindro",
    "conos",
    "docena",
    "docena por 10**6",
    "fardo",
    "galon ingles (4,545956l)",
    "gramo",
    "gruesa",
    "hectolitro",
    "hoja",
    "juego",
    "kilogramo",
    "kilometro",
    "kilovatio hora",
    "kit",
    "latas",
    "libras",
    "litro",
    "megawatt hora",
    "metro",
    "metro cuadrado",
    "metro cubico",
    "miligramos",
    "mililitro",
    "milimetro",
    "milimetro cuadrado",
    "milimetro cubico",
    "millares",
    "millon de unidades",
    "onzas",
    "paletas",
    "paquete",
    "par",
    "pies",
    "pies cuadrados",
    "pies cubicos",
    "piezas",
    "placas",
    "pliego",
    "pulgadas",
    "resma",
    "tambor",
    "tonelada corta",
    "tonelada larga",
    "toneladas",
    "tubos",
    "unidad",
    "unidad (servicios)",
    "us galon (3,7843 l)",
    "yarda",
    "yarda cuadrada",
  ],
};
